// Load Stax (Fattmerchant) client SDK
const STAX_JS_URL = 'https://fattjs.fattpay.com/js/fattmerchant.js';

export async function loadStaxScript() {
  if (typeof window === 'undefined') return;
  if (window.StaxJs) return;

  // Avoid duplicate injection
  if (document.querySelector(`script[src="${STAX_JS_URL}"]`)) {
    // Script tag exists but StaxJs not yet defined — wait for it
    await new Promise((resolve) => {
      const check = setInterval(() => {
        if (window.StaxJs) { clearInterval(check); resolve(); }
      }, 50);
      setTimeout(() => { clearInterval(check); resolve(); }, 5000);
    });
    return;
  }

  await new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = STAX_JS_URL;
    s.onload = () => resolve();
    s.onerror = (e) => reject(new Error('Failed to load Stax SDK'));
    document.head.appendChild(s);
  });
}

// Keep old export name for StaxProcessor.js compatibility
export const loadStaxScriptFromEnv = loadStaxScript;
